'use client';
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import * as React from "react";
import { Icon } from "@tameeni/icons";
import { Slot } from "@radix-ui/react-slot";
import inputVariants from "./input-variants.js";
const Input = React.forwardRef(
  ({
    className,
    id,
    isInvalid,
    invalidMessage,
    succeeded,
    type,
    prefix,
    suffix,
    ...props
  }, ref) => {
    const { root, input, label, suffixIcon, prefixIcon } = inputVariants({
      error: isInvalid,
      success: succeeded
    });
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: root({ className }), children: [
        /* @__PURE__ */ jsx(Slot, { className: prefixIcon(), children: prefix }),
        /* @__PURE__ */ jsx(
          "input",
          {
            type,
            id: id || "input",
            className: input(),
            ref,
            ...props,
            placeholder: " "
          }
        ),
        /* @__PURE__ */ jsx(Slot, { className: suffixIcon(), children: suffix }),
        /* @__PURE__ */ jsx("label", { htmlFor: id || "input", className: label(), children: props.placeholder })
      ] }),
      isInvalid && invalidMessage && /* @__PURE__ */ jsxs("div", { className: "flex mt-2 gap-1 items-center", children: [
        /* @__PURE__ */ jsx(Icon, { name: "Delete", className: "size-4 text-red-500" }),
        /* @__PURE__ */ jsx("span", { className: "text-red-500 text-s3", children: invalidMessage })
      ] })
    ] });
  }
);
Input.displayName = "Input";
export {
  Input
};
